import React, { Component } from "react";

import AddToCartStatue from "../AddToCartStatue";

import { imgSrcAddPrefix } from "../../utility/global";

export default class AddToCartProductListModal extends Component {
    render() {
        const {
            updateShowAddToCartProductListModal,
            isShowAddToCartProductListModal,
            readyAddToCartList,
            alreadyAddToCartList,
            listData,
            isShowResult,
            // isLoading。
        } = this.props;

        return (
            <div
                className={
                    isShowAddToCartProductListModal
                        ? "modal fade show d-flex"
                        : "modal fade show"
                }
                id="AddToCartProductListModal"
                tabIndex="-1"
                aria-labelledby="loginErrorModalLiveLabel"
                aria-modal="true"
                role="dialog"
                onClick={(e) => {
                    // e.preventDefault();
                    e.stopPropagation();
                    // updateShowAddToCartProductListModal(false)
                }}>
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5
                                className="modal-title"
                                id="loginErrorModalLabel">
                                產品組合清單正在加入購物車...
                            </h5>
                            {/* <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close"
                onClick={(e) => updateShowAddToCartProductListModal(false)}
              >
              </button> */}
                        </div>
                        <div className="modal-body">
                            <ul className="list-group mb-3">
                                {!listData
                                    ? null
                                    : listData.map(
                                          (listDataItem, listDataIndex) => {
                                              if (listDataItem.sku !== "0") {
                                                  return (
                                                      <li
                                                          key={listDataIndex}
                                                          className="list-group-item d-flex justify-content-start">
                                                          <div className="listImg">
                                                              <img
                                                                  className="img-fluid"
                                                                  src={imgSrcAddPrefix(
                                                                      listDataItem.image
                                                                  )}
                                                                  alt="img"
                                                              />
                                                          </div>
                                                          <div className="my-auto w-100">
                                                              <h6
                                                                  className="my-0"
                                                                  style={{
                                                                      width: "100%",
                                                                  }}>
                                                                  {
                                                                      listDataItem.name
                                                                  }
                                                                  <span>
                                                                      {" "}
                                                                      x{" "}
                                                                      {
                                                                          listDataItem.qty
                                                                      }
                                                                  </span>
                                                              </h6>
                                                              <div className="d-flex justify-content-between">
                                                                  <small>
                                                                      {
                                                                          listDataItem.sku
                                                                      }
                                                                  </small>
                                                                  <div className="api_resultWrap">
                                                                      {
                                                                          <AddToCartStatue
                                                                              isShowResult={
                                                                                  isShowResult
                                                                              }
                                                                              alreadyAddToCartList={
                                                                                  alreadyAddToCartList
                                                                              }
                                                                              listDataItem={
                                                                                  listDataItem
                                                                              }
                                                                          />
                                                                      }
                                                                  </div>
                                                              </div>
                                                          </div>
                                                      </li>
                                                  );
                                              }
                                              return <></>;
                                          }
                                      )}
                            </ul>
                        </div>
                        <div
                            className={`modal-footer ${
                                readyAddToCartList.length === 0 ? "" : "d-none"
                            }`}>
                            <button
                                type="button"
                                className="btn"
                                data-dismiss="modal"
                                onClick={(e) =>
                                    updateShowAddToCartProductListModal(false)
                                }>
                                關閉
                            </button>
                            <a className="btn" href="/cart">
                                結帳去
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
